import { useState } from 'react';
import PropTypes from 'prop-types';

function FullscreenButton({ onToggleFullscreen, isFullscreen }) {
  return (
    <button
      className="btn btn--secondary btn--sm"
      onClick={onToggleFullscreen}
      title={isFullscreen ? 'Exit fullscreen (Esc)' : 'View fullscreen (F11)'}
      aria-label={isFullscreen ? 'Exit fullscreen' : 'Enter fullscreen'}
    >
      {isFullscreen ? '⏏️ Exit Fullscreen' : '⛶ Fullscreen'}
    </button>
  );
}

FullscreenButton.propTypes = {
  onToggleFullscreen: PropTypes.func.isRequired,
  isFullscreen: PropTypes.bool.isRequired
};

export default FullscreenButton;
